import { isNil, isUndefined } from 'es-toolkit'

type QueryValue = string | number | boolean | Date | null | undefined

type QueryInput = Record<string, QueryValue | QueryValue[]>

// Dates go out as ISO, the only form the backend model binder parses
function serialize(value: QueryValue) {
  if (isNil(value)) return ''
  return value instanceof Date ? value.toISOString() : String(value)
}

export const qs = {
  stringify(query: QueryInput) {
    const params = new URLSearchParams()
    for (const [key, value] of Object.entries(query)) {
      if (isUndefined(value)) continue
      if (Array.isArray(value)) {
        for (const item of value) {
          if (!isUndefined(item)) {
            params.append(key, serialize(item))
          }
        }
      } else {
        params.set(key, serialize(value))
      }
    }
    return params.toString()
  },
}
